// extracted by mini-css-extract-plugin
export default {"breadcrumbs-trigger":"Breadcrumbs-module__breadcrumbs-trigger___ANYJl","breadcrumbs-link":"Breadcrumbs-module__breadcrumbs-link___rSNFl"};